/* AK: mouse drag for anything that scrolls sideways and is marked [data-akh-drag]
   (product carousels, product gallery + thumbnails, size-chart tables…).
   Touch keeps the browser's native swipe; this only adds "grab and pull" for a
   mouse. Carousels (with .slider__slide items) snap to a card when released;
   anything else (a wide table) simply stays where it is let go.
   Hand cursor only while the element really can scroll (class .is-draggable).
   The home category carousel has its own copy of this in sections/collection-list.liquid. */
(function () {
  if (window.akhDragScroll) return;
  window.akhDragScroll = true;

  var SELECTOR = '[data-akh-drag]';
  var drag = null;

  function scrollable(el) {
    return el.scrollWidth > el.clientWidth + 1;
  }

  function slidesOf(el) {
    return el.querySelectorAll('.slider__slide');
  }

  function stepOf(el) {
    var slides = slidesOf(el);
    return slides.length > 1
      ? slides[1].getBoundingClientRect().left - slides[0].getBoundingClientRect().left
      : 0;
  }

  // hand cursor only where there is something to drag (grids on desktop stay normal)
  document.addEventListener('pointerover', function (e) {
    if (e.pointerType !== 'mouse' || !e.target.closest) return;
    var el = e.target.closest(SELECTOR);
    if (el) el.classList.toggle('is-draggable', scrollable(el));
  });

  document.addEventListener('dragstart', function (e) {
    if (e.target.closest && e.target.closest(SELECTOR)) e.preventDefault();
  });

  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'mouse' || e.button !== 0 || !e.target.closest) return;
    var el = e.target.closest(SELECTOR);
    if (!el || !scrollable(el)) return;
    drag = { el: el, x: e.clientX, left: el.scrollLeft, moved: false };
  });

  document.addEventListener('pointermove', function (e) {
    if (!drag) return;
    var dx = e.clientX - drag.x;
    if (!drag.moved && Math.abs(dx) > 5) {
      drag.moved = true;
      drag.el.classList.add('is-dragging');
    }
    if (drag.moved) {
      e.preventDefault();
      drag.el.scrollLeft = drag.left - dx;
    }
  });

  function endDrag(e) {
    if (!drag) return;
    var d = drag;
    drag = null;
    if (!d.moved) return;

    var el = d.el;
    el.classList.remove('is-dragging');

    var step = stepOf(el);
    if (step > 0) {
      // carousel: land on a card — a short pull is enough to move one card,
      // a long one lands on the nearest card
      var maxIndex = Math.ceil((el.scrollWidth - el.clientWidth) / step);
      var dx = (e && e.clientX !== undefined ? e.clientX : d.x) - d.x;
      var start = Math.round(d.left / step);
      var index = Math.round(el.scrollLeft / step);
      if (index === start && dx < -40) index += 1;
      else if (index === start && dx > 40) index -= 1;
      index = Math.max(0, Math.min(maxIndex, index));

      el.classList.add('is-settling'); // keep snapping off until it lands
      el.scrollTo({ left: index * step, behavior: 'smooth' });
      setTimeout(function () {
        el.classList.remove('is-settling');
      }, 600);
    }

    // the click that follows a drag must not open the product / photo
    var swallow = function (ev) {
      ev.preventDefault();
      ev.stopPropagation();
    };
    el.addEventListener('click', swallow, { capture: true, once: true });
    setTimeout(function () {
      el.removeEventListener('click', swallow, { capture: true });
    }, 0);
  }

  document.addEventListener('pointerup', endDrag);
  document.addEventListener('pointercancel', endDrag);
})();
